"use client"

import { LogIn } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LogInIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LogInIcon = component(Icon)({ as: LogIn })
